import React from 'react';
import { ItineraryItem } from '../../types/Quotation';

interface TransferTableProps {
  itinerary: ItineraryItem[];
  onRemove?: (dayIndex: number, transferIndex: number) => void;
  hideActions?: boolean;
}

const TransferTable: React.FC<TransferTableProps> = ({ itinerary, onRemove, hideActions = false }) => {
  const rows = itinerary.flatMap((day, dayIndex) =>
    (day.transfers || []).map((t, transferIndex) => ({ ...t, day: day.day, dayIndex, transferIndex }))
  );

  if (!rows.length) return null;

  const currencySymbol = (c?: string) => (c === 'USD' ? '$' : c === 'EUR' ? '€' : '₹');

  return (
    <table className="flight-table">
      <thead>
        <tr>
          <th>Day</th>
          <th>Vehicle</th>
          <th>Pickup</th>
          <th>From</th>
          <th>To</th>
          <th>Price</th>
          {!hideActions && <th>Action</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((t, idx) => (
          <tr key={idx}>
            <td>{t.day}</td>
            <td>{t.vehicle || '-'}</td>
            <td>{t.pickupDate} {t.pickupTime}</td>
            <td>{t.pickupFromAirport ? (t.airportName || t.airportCode || '-') : (t.hotelName || t.hotelCode || '-')}</td>
            <td>{t.pickupFromAirport ? (t.hotelName || t.hotelCode || '-') : (t.airportName || t.airportCode || '-')}</td>
            <td>
              {currencySymbol(t.currency)}{Number(t.price || 0).toLocaleString('en-IN')}
            </td>
            {!hideActions && onRemove && (
              <td>
                <button onClick={() => onRemove(t.dayIndex, t.transferIndex)}>×</button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TransferTable;
